module.exports = __webpack_public_path__ + "img/base_activites_visite_guidee.2893cac3.svg";